var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "plant-item-opportunity-details-modal",
        "data-toggle": "modal",
        tabindex: "-1",
        role: "dialog",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-lg modal-dialog-centered",
          staticStyle: { "max-width": "1200px" },
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h5", { staticClass: "modal-title" }, [
                _vm._v(" " + _vm._s(_vm.$t("opportunityModalTitle")) + " "),
              ]),
              _vm._m(0),
            ]),
            _c("div", { staticClass: "modal-body pt-3" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 text-center" }, [
                  _c(
                    "table",
                    { staticClass: "table table-sm table-bordered" },
                    [
                      _c("tr", [
                        _c("th", [_vm._v(_vm._s(_vm.$t("opportunityId")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("opportunityTitle")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("irr")))]),
                        _c("th", [
                          _vm._v(
                            _vm._s(_vm.$t("investmentCost")) +
                              " (K" +
                              _vm._s(_vm.getCurrencySymbol()) +
                              ")"
                          ),
                        ]),
                        _c("th", [
                          _vm._v(
                            _vm._s(_vm.$t("benefitCost")) +
                              " (K" +
                              _vm._s(_vm.getCurrencySymbol()) +
                              ")"
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [
                          _vm._v(_vm._s(_vm.opportunity.opportunityId)),
                        ]),
                        _c("td", [
                          _vm._v(_vm._s(_vm.opportunity.opportunityTitle)),
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.opportunity.irr))]),
                        _c("td", [
                          _vm._v(
                            "K" +
                              _vm._s(_vm.getCurrencySymbol()) +
                              " " +
                              _vm._s(_vm.opportunity.investmentCost)
                          ),
                        ]),
                        _c("td", [
                          _vm._v(
                            "K" +
                              _vm._s(_vm.getCurrencySymbol()) +
                              " " +
                              _vm._s(_vm.opportunity.benefitCost)
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: { type: "button", "data-dismiss": "modal" },
      },
      [_c("span", [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }